<div class="dialog-wrapper">
  <div class="float-head">
    <button mat-icon-button (click)="closePanel()" class="custom-mat-icon-button button-close-panel">
      <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
    </button>
  </div>
  <div class="body">
    <div class="body-wrapper">
      <div class="body-container">
        <element-card class="element-card"
          [_bodyDescription]="customerCardBodyDescription"
          [_bodyImage]="customerCardBodyImage"
          [_bodyTitle]="customerCardBodyTitle"
          [_linkPath]="customerCardLinkPath"
          [_linkText]="customerCardLinkText"
          (_goToPath)="goToPath($event)"
        ></element-card>
        <element-card class="element-card"
          [_bodyDescription]="productCardBodyDescription"
          [_bodyImage]="productCardBodyImage"
          [_bodyTitle]="productCardBodyTitle"
          [_linkPath]="productCardLinkPath"
          [_linkText]="productCardLinkText"
          (_goToPath)="goToPath($event)"
        ></element-card>
        <element-card class="element-card"
          [_bodyDescription]="subscriptionCardBodyDescription"
          [_bodyImage]="subscriptionCardBodyImage"
          [_bodyTitle]="subscriptionCardBodyTitle"
          [_linkPath]="subscriptionCardLinkPath"
          [_linkText]="subscriptionCardLinkText"
          (_goToPath)="goToPath($event)"
        ></element-card>
        <element-card class="element-card"
          [_bodyDescription]="invoiceCardBodyDescription"
          [_bodyImage]="invoiceCardBodyImage"
          [_bodyTitle]="invoiceCardBodyTitle"
          [_linkPath]="invoiceCardLinkPath"
          [_linkText]="invoiceCardLinkText"
          (_goToPath)="goToPath($event)"
        ></element-card>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="footer-wrapper">
      <div class="footer-container">
        <a mat-button [disabled]="true" class="custom-mat-link link-button hasIco">
          <mat-icon svgIcon="ico-settings" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
          <span class="label-button">Manage Shortcuts</span>
        </a>
      </div>
    </div>
  </div>
</div>
